import { CircularProgress, Icon } from '@mui/material';
import MyGridView from 'components/GridView';
import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MyFunctions from 'functions/myFunctions';
import withAuth from 'functions/withAuth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import extraFieldsService from 'services/extraFieldsService';
const ExtraFieldsList = () => {
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    let navigate = useNavigate();

    function getAllData() {
        extraFieldsService.getAll().then(res => {
            setData([...res]);
            setIsDataLoaded(true);
        });
    }

    useEffect(() => {
        getAllData();
    }, []);

    if (!isDataLoaded) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <CircularProgress color="success" size={60} />
                <p style={{ color: 'green' }}>الرجاء الإنتظار</p>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="_container">
                <MyGridView
                    source={data}
                    columns={[
                        {
                            "field": "fieldName",
                            "headerText": "الحقل",
                            "width": 70,
                            "textAlign": "right"
                        },
                    ]}
                    allowFiltering={true}
                    actionButtons={[
                        {
                            "content": <Icon color='info'>edit</Icon>,
                            "action": (id) => {
                                return navigate("/extraFields/" + id)
                            }
                        },
                        {
                            "content": <Icon color='error'>delete</Icon>,
                            "action": (id) => {
                                MyFunctions.showConfirmationMessage("عملية حذف", "هل أنت متأكد من الحذف!", () => {
                                    extraFieldsService.delete(id).then(res => {
                                        getAllData();
                                    });
                                })
                            }
                        },
                    ]}
                    addAction={() => {
                        return navigate("/extraFields/" + 0)
                    }}
                />
            </div>
            <Footer />
        </DashboardLayout>
    );
}

export default withAuth(ExtraFieldsList);
